import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
  Fragment,
} from "react";
import {
  Button,
  Alert,
  Card,
  CardBody,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Media,
  Row,
  UncontrolledDropdown,
  Table,
  Badge,
} from "reactstrap";
import {
  fetchDebtsToPayProviderTotal,
  fetchDebtsToPayProviderTotalPending,
} from "../../helpers/api/finance";
import useSWRFetchPagination from "../../helpers/hooks/useSWRFetchPagination";
import FalconCardHeader from "../common/FalconCardHeader";
import Calendar from "../common/Calendar";
import PageHeader from "../common/PageHeader";
import NumberFormat from "react-number-format";
import FullPagination from "../common/pagination/FullPagination";
import { useSelector } from "react-redux";
import withRedirect from "../../helpers/hoc/withRedirect";
import Filter from "../common/Filter";
import { Or, PreloadState } from "../UI/preloading/PreloadState";
import { isIterableArray } from "../../helpers/utils";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import SupportLink from "../root/support/components/SupportLink";
import { CurrencyContext } from "../../context/Context";
import ButtonIcon from "../common/ButtonIcon";
import html2canvas from "html2canvas";
// eslint-disable-next-line import/no-named-as-default
import jsPDF from "jspdf";
import { useReactToPrint } from "react-to-print";
import ItemImageTitleSubProperty from "../common/ItemImageTitleSubProperty";
import { findOneConfig } from "../../helpers/api/condominium";
import useSWRFetch from "../../helpers/hooks/useSWRFetch";
import { getProvider } from "../../helpers/api/provider";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import useModuleBase from "../../helpers/hooks/useModuleBase";

const PaymentsProviderOne = ({ title }) => {
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const moduleBase = useModuleBase();
  const { condominium, address, phone } = useSelector(
    (state) => state.condominium
  );
  const { data: dataConfig, isLoading: loadingConfig } = useSWRFetch(
    selectedCondominium,
    findOneConfig
  );
  console.log(title);
  const { role } = useSelector((state) => state.auth.user);
  const history = useHistory();
  const { provider } = useParams();
  const [dataP, setData] = useState(null);
  const [errorP, setError] = useState(null);
  const [isLoadingP, setIsLoading] = useState(true);
  const [formDate, setformDate] = useState({
    since: null,
    to: null,
  });
  const [totalPending, setTotalPending] = useState([]);
  const [params, setParams] = useState({
    paymented: null,
    condominiumId: selectedCondominium,
    start_date: null,
    end_date: null,
    provider_id: provider,
  });
  const reportRef = useRef();

  /*   const [paramsTotal, setParamsTotal] = useState({
    status: null,
    condominiumId: selectedCondominium,
    start_date: null,
    end_date: null,
    provider_id: provider,
  }); */

  const { currency: curr, baseCurrency } = useContext(CurrencyContext);

  const resolvePayDisplayRate = (pay) => {
    const rawStoredRate = pay?.exchange_rate?.value ?? pay?.exchange_rate ?? null;
    const storedRate = Number(rawStoredRate || 0);

    if (storedRate > 0) {
      return storedRate;
    }

    return Number(curr?.value || 1);
  };

  const filter_options = [
    { value: "", displayName: "Todos", disabled: false },
    { value: 0, displayName: "Pendientes", disabled: false },
    { value: 1, displayName: "Pagados", disabled: false },
  ];

  const {
    data,
    error,
    isLoading,
    meta,
    handler: { goToPage, nextPage, perPage, previousPage },
  } = useSWRFetchPagination(fetchDebtsToPayProviderTotal, params);

  console.log(error);

  const fetchApiProvider = useCallback(async () => {
    try {
      const response = await fetchDebtsToPayProviderTotalPending(params);
      setTotalPending(response);
    } catch (error) {
      console.error("Error al obtener datos desde la API:", error);
      setTotalPending([]);
    }
  }, [params]);

  useEffect(() => {
    fetchApiProvider();
  }, [fetchApiProvider]);

  useEffect(() => {
    let isMounted = true;
    if (provider) {
      (async () => {
        !!isMounted && setIsLoading(true);
        try {
          const { data } = await getProvider(provider);
          !!isMounted && setData(data);
        } catch (error) {
          handleErrorMessage(error);
          !!isMounted && setError(error);
        } finally {
          !!isMounted && setIsLoading(false);
        }
      })();
    }
    return () => {
      isMounted = false;
    };
  }, [provider]);

  console.log(dataP);

  const handleDownload = async () => {
    const canvas = await html2canvas(reportRef.current, {
      windowWidth: reportRef.current.scrollWidth,
      windowHeight: reportRef.current.scrollHeight,
    });
    const imgData = canvas.toDataURL("image/png");

    // eslint-disable-next-line new-cap
    const pdf = new jsPDF("p", "mm", "a4"); // A4 size page of PDF

    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

    pdf.save("Movimientos - Caja.pdf");
  };

  const handlePrint = useReactToPrint({
    content: () => reportRef.current,
  });

  const months = [
    "Ene",
    "Feb",
    "Mar",
    "Abr",
    "May",
    "Jun",
    "Jul",
    "Ago",
    "Sep",
    "Oct",
    "Nov",
    "Dic",
  ];

  const getDate = (date) => {
    const d = new Date(date);
    return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
  };

  const renderItems = () =>
    data.map((payment, i) => {
      const date = new Date(payment?.created_at);
      return (
        <Row key={i} className="alert-success border-top py-3">
          <Col>
            <Row>
              <Col>
                <Row>
                  <Col xs={9} className="d-flex align-items-center">
                    <Media>
                      <Calendar
                        month={months[date.getMonth()]}
                        day={date.getDate()}
                      />
                      <Media
                        body
                        className="position-relative pl-3 align-self-center"
                      >
                        <p className="mb-0">
                          Pago al proveedor{" "}
                          {payment?.debts_to_pay_id?.finance?.provider?.name}{" "}
                        </p>
                        <p className="fs--1 mb-0 font-weight-bolder">
                          Pago realizado
                        </p>
                      </Media>
                    </Media>
                  </Col>
                  <Col
                    xs={3}
                    className=" d-flex align-items-center justify-content-end"
                  >
                    <Media>
                      <Media
                        body
                        className="border-left position-relative pl-3"
                      >
                        <p className="mb-0 font-weight-bolder">Monto</p>
                        <p className="fs--1 mb-0 text-600">
                          <NumberFormat
                            className="text-nowrap"
                            displayType="text"
                            value={payment?.amount}
                            thousandSeparator
                            decimalScale={2}
                            fixedDecimalScale
                            prefix={`${baseCurrency.symbol} `}
                          />
                          <NumberFormat
                            className="text-nowrap"
                            displayType="text"
                            prefix={" | " + curr?.currency?.iso + " "}
                            allowedDecimalSeparators={true}
                            decimalScale={2}
                            fixedDecimalScale
                            thousandSeparator={true}
                            value={payment?.amount * resolvePayDisplayRate(payment)}
                          />
                        </p>
                      </Media>
                    </Media>
                  </Col>
                </Row>
              </Col>
              <Col
                xs="auto"
                className="d-sm-flex align-items-center justify-content-end"
              >
                <UncontrolledDropdown
                  direction="left"
                  className="d-inline-block ml-2"
                >
                  <DropdownToggle color="falcon-default" size="sm">
                    <FontAwesomeIcon icon="ellipsis-h" />
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem
                      /*     onClick={() => handleEdit(cost.id)} */
                      onClick={() =>
                        history.push({
                          pathname: `/dashboard/${moduleBase}/${selectedCondominium}/topay-provider/edit/${payment.debts_to_pay_id.id}`,
                        })
                      }
                    >
                      Ver detalles
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Col>
            </Row>
          </Col>
        </Row>
      );
    });

  return (
    <Fragment>
      <PageHeader
        title={"Cuentas por pagar"}
        titleTag="h2"
        description={"Visualiza las cuentas por pagar del condominio."}
        className="mb-3"
        col={{ lg: 9 }}
      >
        {role === "manager" && <SupportLink />}
      </PageHeader>

      <Card className="p-0 mb-3">
        <FalconCardHeader title="Cuentas por pagar">
          <Row>
            <Col xs={12}>
              <Filter
                keyField="paymented"
                options={filter_options}
                selectType={setParams}
                dateFilter={true}
              />
            </Col>
          </Row>
        </FalconCardHeader>
        <CardBody>
          <Row className="justify-content-between align-items-center d-flex">
            <Col md>
              <h5 className="mb-2 mb-md-0">Descargar movimientos</h5>
            </Col>
            <Col
              xs="auto"
              lg={"auto"}
              md={12}
              className="justify-self-end d-flex justify-content-end align-items-center"
            >
              <ButtonIcon
                color="falcon-default"
                size="sm"
                icon="arrow-down"
                onClick={handleDownload}
                disabled={!data}
                className="mr-2 mb-2 mb-sm-0"
              >
                Descargar (.pdf)
              </ButtonIcon>
              <ButtonIcon
                onClick={handlePrint}
                color="falcon-default"
                size="sm"
                icon="print"
                disabled={!data}
                className="mr-2 mb-2 mb-sm-0"
              >
                Imprimir
              </ButtonIcon>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <Card
        innerRef={(e) => {
          reportRef.current = e;
        }}
        style={{
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
        }}
      >
        <CardBody className="fs--1 ">
          <PreloadState cond={isIterableArray(data)} loading={isLoading}>
            <Or value={true}>
              {/* {renderItems()} */}

              <PreloadState cond={isIterableArray(data)} loading={isLoading}>
                <Fragment>
                  <ItemImageTitleSubProperty
                    image={dataConfig?.data?.logo}
                    title1={"Movimientos del proveedor"}
                    titleCondominium={`Condominio: ${condominium}`}
                    titleProperty={"Datos del proveedor"}
                    titleInvoice={"Datos adicionales"}
                    condominium={[
                      {
                        label: "Documento de identificación",
                        value: phone || "No disponible",
                      },
                      /*     {
                        label: "Teléfono",
                        value: userData.phone || "No disponible",
                      }, */
                      { label: "Dirección", value: address },
                    ]}
                    property={[
                      {
                        label: "Proveedor",
                        value: `${dataP?.name || "No disponible"}`,
                      },
                      {
                        label: "Descripción",
                        value: `${dataP?.description || "No disponible"}`,
                      },
                      {
                        label: "Correo",
                        value: `${dataP?.email || "No disponible"}`,
                      },

                      {
                        label: "Documento de identificación",
                        value: `${dataP?.dni || "No disponible"}`,
                      },
                      {
                        label: "Teléfono",
                        value: `${dataP?.phone || "No disponible"}`,
                      },
                    ]}
                    invoice={[
                      {
                        label: "Saldo por pagar",
                        value: (
                          <>
                            <NumberFormat
                              className="text-right text-nowrap"
                              prefix={`${baseCurrency.symbol} `}
                              thousandSeparator
                              decimalScale={2}
                              fixedDecimalScale
                              displayType="text"
                              value={totalPending?.total_amount}
                            />
                            <NumberFormat
                              className="text-right text-nowrap"
                              displayType="text"
                              allowedDecimalSeparators={true}
                              decimalScale={2}
                              fixedDecimalScale
                              thousandSeparator={true}
                              prefix={" | " + curr?.currency?.iso + " "}
                              value={
                                totalPending?.total_amount *
                                Number(curr?.value || 0)
                              }
                            />
                          </>
                        ),
                      },
                    ]}
                    loading={loadingConfig}
                  />
                  {/*      <div className="text-sm-left col-sm-6">
                        <Logo width={150} />
                      </div> */}
                  {/*                    <Col sm={6} className="text-sm-right mt-3 mt-sm-0">
                      <h4>Movimientos del proveedor</h4>
                      <h5>Condominio {condominium}</h5>
                      <p className="fs--1 mb-0">{address}</p>
                      <p className="fs--1 mb-0">RIF {phone}</p>
                      <h6 className="fs--1 mt-2 mb-0">Saldo por pagar</h6>
                      <NumberFormat
                        className="text-right text-nowrap"
                        prefix={`${baseCurrency.symbol} `}
                        thousandSeparator
                        decimalScale={2}
                        fixedDecimalScale
                        displayType="text"
                        value={totalPending?.total_amount}
                      />
                      <NumberFormat
                        className="text-right text-nowrap"
                        displayType="text"
                        allowedDecimalSeparators={true}
                        decimalScale={2}
                        fixedDecimalScale
                        thousandSeparator={true}
                        prefix={" | " + curr?.currency?.iso + " "}
                        value={
                          totalPending?.total_amount * Number(curr?.value || 0)
                        }
                      />
                    </Col> */}

                  {/*          {formDate.to && (
                <div className="d-flex justify-content-end">
                  <h6>
                    Relación de condominio: {params.start_date} al{" "}
                    {params.end_date}
                  </h6>
                </div>
              )} */}

                  {data.length > 0 ? (
                    <>
                      <Fragment>
                        <Table striped bordered hover>
                          <thead>
                            <tr>
                              <th style={{ fontSize: "0.9rem" }}>Fecha</th>
                              <th style={{ fontSize: "0.9rem" }}>
                                Cuenta por pagar
                              </th>

                              <th style={{ fontSize: "0.9rem" }}>Estado</th>
                              <th style={{ fontSize: "0.9rem" }}>Monto</th>
                            </tr>
                          </thead>
                          <tbody>
                            {data.map((movement) => (
                              <tr
                                style={{ fontSize: "0.8rem" }}
                                key={movement.id}
                              >
                                <td>{getDate(movement.created_at)}</td>
                                <td>
                                  {movement.finance && movement.finance.name}
                                </td>

                                <td>
                                  {movement.paymented ? (
                                    <Badge className="rounded-capsule badge-soft-success">
                                      Pagada
                                      <FontAwesomeIcon
                                        className="ml-2 "
                                        /*    icon="fa-solid fa-arrow-up" */
                                      />
                                    </Badge>
                                  ) : (
                                    <Badge className="rounded-capsule badge-soft-warning">
                                      Pendiente
                                      <FontAwesomeIcon
                                        className="ml-2"
                                        /*   icon="fa-solid fa-arrow-down" */
                                      />
                                    </Badge>
                                  )}
                                </td>
                                <td>
                                  <NumberFormat
                                    className="text-right text-nowrap"
                                    prefix={`${baseCurrency.symbol} `}
                                    thousandSeparator
                                    decimalScale={2}
                                    fixedDecimalScale
                                    displayType="text"
                                    value={movement.amount}
                                  />
                                  <NumberFormat
                                    className="text-right text-nowrap"
                                    displayType="text"
                                    allowedDecimalSeparators={true}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    thousandSeparator={true}
                                    prefix={" | " + curr?.currency?.iso + " "}
                                    value={
                                      movement.amount * Number(curr?.value || 0)
                                    }
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </Fragment>
                    </>
                  ) : (
                    <Row className="p-card">
                      <Col>
                        <Alert color="info" className="mb-0">
                          Al parecer aún no hay movimientos para mostrar.
                        </Alert>
                      </Col>
                    </Row>
                  )}
                </Fragment>
              </PreloadState>

              <FullPagination
                style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}
                nextPage={nextPage}
                prevPage={previousPage}
                goToPage={goToPage}
                meta={meta}
                className={"shadow-none"}
                posText={"Movimientos"}
                perPage={perPage}
              />
            </Or>

            <Or value={false} cond={!!error}>
              <Row className="p-card">
                <Col>
                  <Alert color="info" className="mb-0">
                    No se han realizado <b>pagos</b> al proveedor{" "}
                    <b>actualmente</b>.
                  </Alert>
                </Col>
              </Row>
              <Or value={true}>
                <Alert color="danger" className="mb-0">
                  Esta página no está disponible
                  <Button
                    data-testid="Button"
                    color="link"
                    size="sm"
                    className="ml-1 pl-0"
                    onClick={() => history.goBack()}
                  >
                    Volver
                  </Button>
                </Alert>
              </Or>
            </Or>
          </PreloadState>
        </CardBody>
        {/*      <CardFooter>
          {isIterableArray(data) && (
            <FullPagination
              nextPage={nextPage}
              prevPage={previousPage}
              goToPage={goToPage}
              meta={meta}
              className={"shadow-none"}
              posText={"pagos"}
              perPage={perPage}
            />
          )}
        </CardFooter> */}
      </Card>
    </Fragment>
  );
};

export default withRedirect(PaymentsProviderOne);
